export default "__VITE_ASSET__CbKiB3QO__"